import "./app/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { createUnauthorizedHandler } from "./app/createUnauthorizedHandler";
import { initAnalytics } from "./app/initAnalytics";
import { initSentry } from "./app/initSentry";
import { rememberLanding } from "./app/rememberLanding";
import { rememberProPreview } from "./app/rememberProPreview";
import { registerAppRealtimeHandlers } from "./app/registerAppRealtimeHandlers";
import { router } from "./app/router";
import { setUnauthorizedHandler } from "./shared/api";
import { activateLocale, detectLocale } from "./shared/i18n";

initSentry();
initAnalytics();
rememberLanding();
rememberProPreview();
registerAppRealtimeHandlers();
setUnauthorizedHandler(createUnauthorizedHandler(router));

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

// Каталоги языка загружаются до первого рендера, чтобы не мигали непереведённые строки.
await activateLocale(detectLocale());

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
